import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { UserSettingsPage } from "@/settings/users/UserSettingsPage";
import { type UserStatus } from "@/settings/users/UsersTable";
import { type LastLoginOption, USER_ROLES } from "@/settings/users/UsersTable/Filters";

export const userFiltersSchema = z.object({
  search: z.string().optional().catch(undefined),
  status: z
    .enum(["ACTIVE", "INACTIVE", "INVITED"] as const satisfies UserStatus[])
    .optional()
    .catch(undefined),
  role: z.enum(USER_ROLES).optional().catch(undefined),
  showOwnersOnly: z.boolean().optional().catch(undefined),
  lastLoginFilter: z
    .enum(["all", "never", "recent", "older"] as const satisfies LastLoginOption[])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/(authed)/_layout/settings/users")({
  component: UserSettingsPage,
  validateSearch: userFiltersSchema,
  loader: () => ({ crumb: "Users" }),
});
